import React, { useState, useEffect } from 'react';
import { Container, Modal, Button, ListGroup, Spinner, Row, Col } from 'react-bootstrap';
import axios from '../AxiosConfig';

const UserManagement = ({ filter }) => {
  const [approvedUsers, setApprovedUsers] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);
  const [nonAdminUsers, setNonAdminUsers] = useState([]);
  const [unapprovedUsers, setUnapprovedUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("/api/admin/manageUsers");
        const approved = response.data.approved || [];
        setApprovedUsers(approved);
        setAdminUsers(approved.filter((user) => user.is_admin));
        setNonAdminUsers(approved.filter((user) => !user.is_admin));
        setUnapprovedUsers(response.data.unapproved || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleMakeAdmin = async (userId) => {
    try {
      await axios.post(`/api/admin/makeAdmin`, { user_id: userId });
      setNonAdminUsers((users) => users.filter((user) => user.user_id !== userId));
      setAdminUsers((users) => [...users, ...nonAdminUsers.filter((user) => user.user_id === userId)]);
    } catch (error) {
      console.error("Error making user admin:", error);
    }
  };

  const handleRemoveAdmin = async (userId) => {
    try {
      await axios.post(`/api/admin/removeAdmin`, { user_id: userId });
      setAdminUsers((users) => users.filter((user) => user.user_id !== userId));
      setNonAdminUsers((users) => [...users, ...adminUsers.filter((user) => user.user_id === userId)]);
    } catch (error) {
      console.error("Error removing admin:", error);
    }
  };

  const renderUserList = (users, action, actionLabel) =>
    users.map((user) => (
      <ListGroup.Item key={user.user_id} className="d-flex justify-content-between align-items-center">
        {user.first_name} {user.last_name} ({user.user_email})
        {action && (
          <Button variant="primary" onClick={() => action(user.user_id)}>
            {actionLabel}
          </Button>
        )}
      </ListGroup.Item>
    ));

  return (
    <Container>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {filter === "approved" && (
            <Row>
              {/* Admin Users Column */}
              <Col md={6}>
                <h5>Admin Users</h5>
                <ListGroup>
                  {adminUsers.length > 0
                    ? renderUserList(adminUsers, handleRemoveAdmin, "Remove Admin")
                    : <p>No Admin Users</p>}
                </ListGroup>
              </Col>

              {/* Non-Admin Users Column */}
              <Col md={6}>
                <h5>Non-Admin Users</h5>
                <ListGroup>
                  {nonAdminUsers.length > 0
                    ? renderUserList(nonAdminUsers, handleMakeAdmin, "Make Admin")
                    : <p>No Non-Admin Users</p>}
                </ListGroup>
              </Col>
            </Row>
          )}

          {filter === "unapproved" && (
            <ListGroup>
              {unapprovedUsers.length > 0
                ? renderUserList(unapprovedUsers, null, null)
                : <p>No Unapproved Users</p>}
            </ListGroup>
          )}
        </>
      )}
    </Container>
  );
};

export default UserManagement;
